// i18n area 'backups' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.pt-PT.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 arquivo→«cópia de configuração» (#247).
import type { enUS } from './backups'

export const ptPT: typeof enUS = {
  ckpt: {
    contents: 'Aceita',
    contentsHint:
      'O que pode aterrar aqui. «Checkpoints» é a configuração do cluster, «Cópias de dados» são as das VM: as duas leituras compõem-se, um destino pode aceitar ambas.',
    content: { checkpoints: 'Checkpoints', backups: 'Cópias de dados' },
    destinationsTitle: 'Destinos de backup',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Restauro',
    addDestination: 'Adicionar destino',
    addDestinationTitle: 'Adicionar destino de backup',
    editDestinationTitle: 'Editar destino',
    storage: 'Storage',
    storageHint:
      'Um storage dir-like (dir/NFS/CIFS/CephFS) — os artefactos são ficheiros normais sob o namespace da plataforma.',
    schedule: 'Agendamento',
    scheduleNone: 'Apenas manual',
    scheduleHourly: 'De hora a hora',
    scheduleDaily: 'Diário',
    scheduleWeekly: 'Semanal',
    scheduleHour: 'Hora',
    scheduleWeekday: 'Dia',
    scheduleHint:
      'Os checkpoints agendados não têm um operador a digitar a masterpass: os segredos do keystore são empacotados como placeholders.',
    retention: 'Retention',
    retentionHint:
      'Quantos checkpoints agendados manter — o sweeper remove os mais antigos para além da contagem. Os checkpoints manuais e pré-restauro nunca são removidos.',
    paused: 'Em pausa',
    pausedHint:
      'O blackout do operador: enquanto está em pausa, neste destino nada se agenda nem se poda — policies de dados e checkpoints por igual. As execuções em curso nunca são tocadas.',
    orphanRuns: '{n} execuções órfãs',
    orphanRunsHint:
      'Execuções planeadas de policies que já não existem neste destino: nenhuma retenção as governa — nunca contadas nem podadas — e só se eliminam à mão. A lente «backups» do tvirt diagnose nomeia as policies removidas.',
    rescan: 'Readotar artefactos',
    rescanTitle: 'Readoção de artefactos de {name}',
    rescanHint:
      'Reconstrói o catálogo de cópias (VM/CT/App) a partir dos manifestos dos artefactos presentes no destino. As linhas existentes nunca são tocadas; as cópias de políticas desconhecidas ficam órfãs (nunca podadas automaticamente). O gesto após um restauro de bootstrap.',
    masterpassDrWarning:
      'Cenário de desastre: os discos LUKS só regressam de um checkpoint COM masterpass. Os checkpoints agendados empacotam marcadores — tire periodicamente um checkpoint manual com masterpass.',
    policy: {
      title: 'Policies de backup de dados',
      hint: 'Policies com nome: que objetos (kind, tags, scopes), com que frequência, quando pode arrancar uma execução e quantas cópias manter. O gesto de alistamento fica com o dono do objeto: os tags atribuem-se no seu próprio scope.',
      add: 'Adicionar policy',
      column: 'Policies de dados',
      name: 'Nome',
      nameHint:
        'Etiqueta da policy, única no destino. As execuções seguem o id estável da policy: renomear é grátis; eliminá-la torna órfãs as suas execuções (já não contadas nem podadas).',
      kindLocked: 'A família de objetos de uma policy existente não se altera: crie uma policy nova.',
      kindLabel: 'Objetos',
      kind: { vm: 'Máquinas virtuais', ct: 'Containers', app: 'Apps' },
      tags: 'Seletor de tags',
      tagsHint:
        'Pares tag=valor separados por vírgulas, em AND. Tags e scopes vazios não selecionam nada — nunca «tudo».',
      scopes: 'Scopes',
      scopesHint: 'Caminhos de scope (subárvores), separados por vírgulas, em OR entre si.',
      windowStart: 'Janela de',
      windowEnd: 'Janela até',
      windowHint:
        'Janela de execução (HH:MM, hora local; um início além do fim salta a meia-noite). Governa apenas o ARRANQUE: uma execução que a ultrapassa nunca é morta.',
      mode: 'Modo',
      modeHint: 'O incremental cavalga a família de séries; uma série partida degrada para full, dito no diário.',
      modeFull: 'Full',
      modeIncremental: 'Incremental',
      requireQuiesce: 'Exigir quiesce (guest agent)',
      paused: 'Policy em pausa',
      retentionNone: 'Manter tudo',
      retentionCount: 'Contagem',
      retentionGfs: 'Anéis GFS',
      gfs: { keepLast: 'Últimos', daily: 'Diários', weekly: 'Semanais', monthly: 'Mensais', yearly: 'Anuais' },
      gfsHint:
        'Por cada anel mantém-se o backup mais recente de cada um dos últimos N períodos. Um backup mantido mantém viva toda a sua cadeia — nunca uma base com órfãos.',
      lastRun: 'Última execução',
      neverRan: 'nunca executada'
    },
    lastCheckpoint: 'Último checkpoint',
    neverRun: 'Nunca criado',
    createNow: 'Criar checkpoint',
    createNowTitle: 'Criar checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Protege os valores secretos do keystore (argon2id → AES-256-GCM, por valor). Nunca é guardada: conserve-a — sem ela, um restauro produz placeholders em vez dos segredos verdadeiros.',
    masterpassEmptyHint: 'Deixe vazio para empacotar placeholders explícitos em vez dos segredos.',
    createStarted: 'Checkpoint em curso…',
    destinationInUseError: "'{name}' ainda contém checkpoints — elimine-os primeiro.",
    origin: 'Origem',
    originManual: 'manual',
    originSchedule: 'agendado',
    originPreRestore: 'pré-restauro',
    originPreChange: 'pré-alteração',
    preChangeRetention: 'Checkpoints pré-alteração',
    preChangeRetentionHint:
      'Vazio = desativado. A primeira escrita de configuração após um período de calma congela aqui o estado anterior (origem pré-alteração); mantêm-se os mais recentes até à contagem — retenção própria, podável.',
    diffTitle: 'Pré-visualização das alterações',
    diffFailed: 'A pré-visualização falhou',
    diffRetry: 'Tentar novamente',
    diffCounts: '{changed} a alterar · {missing} a criar · {extra} a mais · {equal} idênticos',
    diffChanged: 'muda',
    diffMissing: 'seria criado',
    diffExtra: 'seria eliminado',
    diffJsonb: 'referências jsonb não verificáveis antes da aplicação',
    diffSecret: 'campos selados, não comparáveis',
    diffMore: 'mais {n}…',
    diffNeeded: 'O arranque arma-se quando a pré-visualização reflete a seleção.',
    phase: 'Estado',
    phaseRunning: 'em curso',
    phaseComplete: 'completo',
    phaseError: 'erro',
    secrets: 'Segredos',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholders',
    size: 'Tamanho',
    created: 'Criado',
    destination: 'Destino',
    download: 'Transferir .tvbk',
    deleteCheckpoint: 'Eliminar checkpoint',
    noCheckpoints: 'Nenhum checkpoint — crie um a partir de um destino.',
    families: 'Famílias',
    generation: 'Geração',
    completedAt: 'Concluído em',
    errorDetail: 'Detalhe do erro',
    manifest: 'Manifest',
    restoreHint: 'Carregue um artefacto .tvbk: o explorer mostra o que contém, depois escolha o que restaurar e como.',
    uploadFile: 'Carregar um ficheiro .tvbk',
    uploading: 'A carregar…',
    uploadFailed: 'Impossível abrir o artefacto',
    explorerTitle: 'Conteúdo do checkpoint',
    checkpointFrom: 'Checkpoint do cluster {cluster}, criado em {when} ({origin}, geração {generation})',
    otherCluster:
      'Este checkpoint provém de OUTRO cluster ({cluster}) — o restauro cross-cluster chega num round futuro.',
    encrypted: 'cifrado',
    objectsCount: '{n} objetos',
    mode: 'Modo',
    modeMerge: 'Merge — reconcilia: upsert dos selecionados, não apaga nada',
    modeOverwrite:
      'Overwrite — o checkpoint vence: uma família totalmente selecionada é substituída por inteiro (as linhas atuais ausentes do checkpoint morrem)',
    restoreMasterpassHint:
      'A masterpass com que o checkpoint foi criado. Sem ela, os segredos cifrados são restaurados como placeholders explícitos.',
    checkMasterpass: 'Verificar',
    masterpassOk: 'Masterpass correta',
    masterpassWrong: 'Masterpass errada',
    parachuteDestination: 'Destino paraquedas',
    parachuteHint: 'Antes de tocar em qualquer linha, a task cria aqui um checkpoint automático pré-restauro.',
    summaryTitle: 'O que vai acontecer',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'família inteira',
    summaryObjects: '{n} objetos selecionados',
    confirmHint: 'Digite o nome do cluster ({name}) para confirmar — um restauro reescreve a configuração declarada.',
    confirmField: 'Nome do cluster',
    startRestore: 'Restaurar',
    restoreRunning: 'Restauro em curso…',
    restoreDone: 'Restauro concluído — os reconcilers convergem para a nova declaração.',
    restoreFailed: 'O restauro falhou',
    discard: 'Descartar',
    selectionEmpty: 'Selecione pelo menos uma família ou um objeto.'
  },

  backup: {
    intro: {
      title: 'Backup dos dados de VM e containers',
      subtitle: 'Os tijolos que o software de backup externo usa',
      whatItIs:
        'O TVirt expõe quatro primitivas: snapshots quiesced, change tracking por disco, export NBD só de leitura e export da configuração. Veeam, Bacula, Acronis e afins conduzem-nas.',
      whatItIsNot:
        'O TVirt não é um produto de backup: não agenda nada, não aplica retenção e não guarda nenhuma cópia dos seus dados. Retenção, catálogos e políticas de restauro ficam com o software que já usa.'
    },
    cbt: {
      title: 'Seguimento de alterações',
      colVm: 'VM',
      colDisk: 'Disco',
      colState: 'Estado',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Observado',
      colChangeId: 'Change ID',
      colMechanic: 'Mecânica',
      stateActive: 'Ativo',
      stateInactive: 'Inativo',
      stateInconsistent: 'Incoerente — a próxima cópia tem de ser completa',
      stateBroken: 'Cadeia quebrada — desative e volte a ativar como cadeia nova',
      stateSnapshots: 'Sempre ativo — delta entre snapshots',
      stateUnavailable: 'Indisponível neste disco',
      mechanic: {
        'qcow2-bitmap': 'Bitmap qcow2',
        'rbd-snapdiff': 'Diff de snapshots Ceph',
        'lvm-thin-delta': 'Delta do thin pool',
        none: 'Nenhuma'
      },
      empty: 'Nenhum disco de VM. O seguimento lê-se por disco: ative-o num disco qcow2 ou tire snapshots em rbd/SAN.',
      chainBroken: 'Cadeia quebrada',
      chainBrokenText:
        'Quebrada por um {reason}: {bitmaps}. Desative a bitmap (a cadeia perdeu-se, a próxima cópia é completa) e volte a ativá-la como cadeia nova.',
      lineages: 'Épocas',
      epochFrozen: 'congelada no snapshot {snapshot}',
      epochLost: 'perdida ({cause})',
      epochRecording: 'a gravar na cabeça',
      milestones: 'Marcos (snapshots)',
      enable: 'Ativar o seguimento',
      disable: 'Desativar',
      reset: 'Repor',
      changedAreas: 'Áreas alteradas',
      denied: 'Não tem permissão nesta VM',
      enableTitle: 'Ativar o seguimento de alterações',
      disableTitle: 'Desativar o seguimento de alterações',
      resetTitle: 'Repor a bitmap',
      areasTitle: 'Áreas alteradas',
      bitmapName: 'Nome da bitmap',
      bitmapNameHint: 'Um nome seu: tvirt- e tvbk- são da plataforma',
      granularity: 'Granularidade (bytes)',
      granularityHint: 'Uma potência de dois; 65536 por omissão',
      bitmap: 'Bitmap',
      disableHint: 'Remove a bitmap e todo o seu histórico de épocas: a próxima cópia tem de ser completa.',
      resetHint: 'Esvazia a bitmap — uma base nova: um change ID anterior já não é componível.',
      areasFrom: 'Do snapshot',
      areasTo: 'Até ao snapshot',
      areasRun: 'Calcular',
      areasResult: '{count} áreas alteradas, {bytes}',
      areasEmpty: 'Nenhuma área alterada entre os dois snapshots',
      areasZero: 'zeros',
      areasMore: 'mostradas as primeiras {shown} de {count}',
      submit: 'Confirmar',
      error: 'A ação de seguimento falhou'
    },
    exports: {
      title: 'Exports NBD abertos',
      colVm: 'VM',
      colDisk: 'Disco',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Fase',
      colNode: 'Nó',
      colEndpoint: 'Endpoint',
      colExpires: 'Expira',
      colCreated: 'Aberto',
      colError: 'Erro',
      phase: {
        preparing: 'A preparar',
        ready: 'Pronto',
        closed: 'Fechado',
        error: 'Falhou'
      },
      expiresIn: 'em {minutes} min',
      expired: 'expirado',
      empty: 'Nenhum export. Uma sessão de leitura serve um disco num snapshot a um cliente NBD; uma de escrita preenche um disco virgem de uma VM desligada. Ambas morrem ao expirar.',
      endpointHint: 'TLS com a CA do cluster; o nome do export é o ticket — morre com a sessão',
      closeDenied: 'Não tem permissão para fechar exports desta VM',
      open: 'Abrir export NBD',
      openTitle: 'Abrir um export NBD',
      openDisk: 'Disco',
      openBitmap: 'Bitmap (opcional)',
      openBitmapHint:
        'Publica a época dessa bitmap congelada neste snapshot como meta-context dos extents sujos (só discos qcow2)',
      openTtl: 'Duração (minutos)',
      openSubmit: 'Abrir',
      openError: 'Não foi possível abrir o export',
      colMode: 'Modo',
      mode: {
        read: 'Leitura',
        write: 'Escrita'
      },
      caCertificate: 'CA do cluster',
      caCopy: 'Copiar PEM',
      caDownload: 'Descarregar ca-cert.pem',
      caHint: 'Escreva o PEM em ca-cert.pem numa pasta privada e ligue-se com nbds://…?tls-certificates=<pasta> (nbdcopy, nbdinfo) ou --object tls-creds-x509,dir=<pasta>,endpoint=client (qemu-img)',
      caAbsent: 'A sessão não traz a CA (sem PKI)',
      openWrite: 'Abrir export de escrita',
      openWriteTitle: 'Abrir um export de escrita',
      openWriteIntro: 'O disco tem de ser virgem: nascido vazio, nunca escrito, sem snapshot; a VM desligada. O restauro PREENCHE o disco, não o repara. Enquanto a sessão estiver aberta a VM não arranca, não faz snapshot, não se clona e o disco não se move.',
      openWriteSubmit: 'Abrir',
      openWriteError: 'Não foi possível abrir o export de escrita',
      openWriteDenied: 'Não tem a permissão vm.restore.data nesta VM',
      openWriteStopped: 'Desligue a VM para abrir um export de escrita',
      fromDescription: 'Criar VM a partir da description',
      fromDescriptionTitle: 'Criar uma VM a partir de uma description',
      fromDescriptionIntro: 'A description de export-vm-meta volta como VM desligada com os discos vazios da geometria descrita — pronta para os exports de escrita, disco a disco. Os bytes não passam por aqui: leva-os o restore-disk (CLI) ou o cliente NBD do produto de backup.',
      fromDescriptionDoc: 'Description (JSON)',
      fromDescriptionDocHint: 'Cole o documento de export-vm-meta, ou escolha o ficheiro',
      fromDescriptionFile: 'Escolher ficheiro…',
      fromDescriptionInvalid: 'O texto não é um documento JSON',
      fromDescriptionName: 'Nome da nova VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'O seu scope de partida',
      fromDescriptionStorage: 'Storage dos discos',
      fromDescriptionStorageHint: 'Cada disco nasce aqui, no formato por defeito do storage',
      fromDescriptionMetadataStorage: 'Storage dos metadados',
      fromDescriptionSameAsStorage: 'O mesmo dos discos',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Sem bridge nem rede a VM nasce sem placas',
      fromDescriptionNetwork: 'Rede lógica (fabric/rede)',
      fromDescriptionSubmit: 'Criar',
      fromDescriptionError: 'Não foi possível criar a VM',
      fromDescriptionDone: 'VM criada: {name}',
      fromDescriptionOpen: 'Abrir a VM',
      fromDescriptionDenied: 'Não tem a permissão vm.create',
      fromDescriptionStillRunning: 'A criação ainda está em curso: continua-se a esperar'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Cópias de dados das VM',
      titleOnVm: 'Cópias de dados',
      empty:
        'Nenhuma cópia. Uma cópia leva os discos, o varstore UEFI e o estado do vTPM para um destino, e sobrevive à VM.',
      colVm: 'VM',
      colCreated: 'Efetuada em',
      colPhase: 'Resultado',
      colDestination: 'Destino',
      colContains: 'Conteúdo',
      colSize: 'Tamanho',
      colOrigin: 'Origem',
      colMode: 'Tipo',
      retentionChip: 'Retenção',
      retentionHint:
        'A retenção do destino pode apagar esta cópia sem perguntar: nasceu de um agendamento. As cópias manuais nunca são varridas.',
      policyRemoved: 'Policy removida: {name}',
      policyRemovedHint:
        'A policy que planeou este backup já não existe: nenhuma retenção o governa (nunca podado automaticamente) — elimine-o à mão quando já não for preciso.',
      phase: {
        running: 'Em curso',
        complete: 'Concluída',
        error: 'Falhada'
      },
      origin: {
        manual: 'Manual',
        schedule: 'Agendada'
      },
      mode: {
        full: 'Completa',
        incremental: 'Incremental'
      },
      contains: {
        disks: 'Discos',
        varstore: 'Varstore UEFI',
        vtpm: 'Estado vTPM',
        snapshots: 'Snapshots'
      },
      vmState: {
        stopped: 'VM desligada',
        running: 'VM ligada (a quente)'
      },
      artifactClass: { metadata: 'Metadados', data: 'Dados', secret: 'Segredo' },
      detail: {
        tabOverview: 'Resumo',
        tabArtefact: 'Artefacto',
        id: 'Identificador',
        scope: 'Âmbito',
        vmState: 'Estado da VM na cópia',
        pointInTime: 'Instante dos dados',
        completedAt: 'Terminada em',
        node: 'Nó que copiou',
        error: 'Erro',
        path: 'Pasta no armazenamento',
        checksum: 'sha256 do manifest',
        secretsExposed: 'Material sensível em claro',
        secretsExposedYes: 'Sim — o destino não cifra',
        secretsExposedNo: 'Não',
        baseBackup: 'Cópia de base',
        tabManifest: 'Manifest',
        manifestHint:
          'O índice em claro do artefacto: um ficheiro por linha com o seu sha256. A pasta verifica-se mesmo sem TVirt — bastam qemu-img, tar e jq.',
        manifestEmpty: 'O manifest não lista ficheiros.',
        manifestError: 'O manifest não é legível',
        colEntry: 'Ficheiro',
        colClass: 'Classe',
        colSha: 'sha256'
      },
      create: {
        action: 'Copiar agora',
        title: 'Copiar agora',
        submit: 'Iniciar a cópia',
        destination: 'Destino',
        destinationHint: 'Apenas os destinos que aceitam cópias.',
        noDestinations: 'Nenhum destino aceita cópias: crie um em Sistema → Checkpoints.',
        contentsHint:
          'Viajam todos os discos, o varstore UEFI e o estado do vTPM. Os dois últimos são o ponto: um guest selado tem de voltar a arrancar.',
        error: 'A cópia não arrancou',
        stillRunning: 'Cópia ainda em curso — continua mesmo que feche.',
        vmRunning:
          'A VM está {phase}: a cópia exige uma VM estável — desligada para a cópia a frio, ligada para a cópia a quente.'
      },
      restore: {
        action: 'Restaurar',
        title: 'Restaurar',
        intro:
          'O restauro é irreversível. Escolha para onde voltam os dados: para uma máquina nova, ou por cima da de partida.',
        modeNewVm: 'Restaurar numa VM NOVA',
        modeNewVmHint:
          'Não toca em nada do que existe — é a opção com que se verifica uma cópia. Identificador novo e MAC acabadas de cunhar.',
        modeOver: 'Sobrescrever a VM de partida',
        modeOverHint: 'Destrói os dados atuais da VM de destino, sem volta. A VM tem de estar desligada.',
        newName: 'Nome da nova VM',
        newNameHint: 'Tem de estar livre no âmbito de destino.',
        storage: 'Armazenamento dos discos',
        storageHint:
          'Obrigatório: o manifest regista o tamanho e o formato de um disco, nunca o armazenamento de onde vinha.',
        metadataStorage: 'Armazenamento de varstore e vTPM',
        metadataStorageHint: 'Onde aterram a identidade UEFI e o estado do vTPM.',
        sameAsStorage: 'O mesmo dos discos',
        bridge: 'Bridge do host',
        bridgeHint:
          'Cada placa registada volta nesta bridge com um MAC novo. Deixado vazio, a VM nasce sem placas — o valor por omissão mais seguro.',
        overwriteTitle: 'Está prestes a sobrescrever esta VM',
        overwriteName: 'Nome',
        overwriteId: 'Identificador',
        overwriteDisks: 'Discos que serão reescritos',
        overwriteNoDisks: 'Nenhum disco.',
        overwriteKeeps:
          'Ficam intactos identificador, nome, âmbito, placas de rede e MAC: uma cópia são os DADOS, a configuração é o checkpoint.',
        confirmField: 'Nome da VM',
        confirmHint: 'Escreva {name} para confirmar.',
        targetLoading: 'A ler a VM de destino…',
        targetRunning:
          'A VM de destino está {phase}: o restauro reescreve os bytes por baixo do guest, por isso quer-a desligada.',
        targetGone: 'A VM de partida já não é legível: resta o restauro numa VM nova.',
        onlyComplete: 'A cópia está {phase}: só uma cópia concluída pode restaurar.',
        submitNewVm: 'Restaurar na nova VM',
        submitOver: 'Sobrescrever',
        error: 'O restauro não arrancou',
        stillRunning: 'Restauro ainda em curso — copiar discos inteiros leva tempo.'
      }
    },
    guest: {
      title: {
        ct: 'Cópias de dados dos contentores',
        app: 'Cópias de dados das App'
      },
      tabTitle: 'Cópias',
      empty: 'Sem cópias. Uma cópia leva os dados persistentes para um destino e sobrevive ao seu objeto.',
      colSubject: {
        ct: 'Contentor',
        app: 'App'
      },
      colCreated: 'Realizada',
      colPhase: 'Resultado',
      colDestination: 'Destino',
      colContains: 'Conteúdo',
      colSize: 'Tamanho',
      colOrigin: 'Origem',
      policyRemoved: 'Policy removida: {name}',
      policyRemovedHint:
        'A policy que planeou este backup já não existe: nenhuma retenção o governa (nunca podado automaticamente) — elimine-o à mão quando já não for preciso.',
      phase: {
        running: 'Em curso',
        complete: 'Concluída',
        error: 'Falhada'
      },
      origin: {
        manual: 'Manual',
        schedule: 'Agendada'
      },
      state: {
        stopped: 'Objeto parado',
        running: 'Objeto em execução (congelado)'
      },
      contains: {
        rootfs: 'Árvore rootfs',
        config: 'Configuração',
        volumes: 'Volumes persistentes',
        root: 'Root persistente'
      },
      artifactClass: {
        metadata: 'Metadados',
        data: 'Dados',
        secret: 'Segredo'
      },
      create: {
        action: 'Fazer cópia agora',
        title: 'Nova cópia',
        submit: 'Iniciar a cópia',
        error: 'A cópia não arrancou',
        destination: 'Destino',
        destinationHint: 'Apenas os destinos que aceitam cópias de dados.',
        noDestinations: 'Nenhum destino aceita cópias de dados: adicione «Cópias de dados» a um destino.',
        hint: {
          ct: 'Viaja a árvore rootfs inteira, fielmente (proprietários numéricos, xattrs, ACL), mais a configuração declarada no manifesto. Um contentor em execução é CONGELADO durante todo o empacotamento: cópia crash-consistent, declarada.',
          app: 'Viajam APENAS os volumes persistentes (e a root persistente), mais a configuração no manifesto. O efémero fica excluído por ratificação e o manifesto nomeia-o; os valores env declarados secretos não viajam.'
        },
        stillRunning: 'Cópia ainda em curso — empacotar árvores inteiras leva tempo.'
      },
      detail: {
        tabOverview: 'Resumo',
        tabManifest: 'Manifesto',
        id: 'Identificador',
        scope: 'Âmbito',
        state: 'Estado na cópia',
        pointInTime: 'Dados no instante',
        completedAt: 'Concluída em',
        node: 'Nó que copiou',
        error: 'Erro',
        path: 'Pasta no armazenamento',
        checksum: 'sha256 do manifesto',
        manifestHint:
          'O índice do artefacto: uma entrada por ficheiro com o seu sha256 — sem os hashes, «a cópia está lá» é um ato de fé.',
        manifestError: 'O manifesto não pode ser lido',
        manifestEmpty: 'Sem artefactos no manifesto.',
        colEntry: 'Ficheiro',
        colClass: 'Classe',
        colSha: 'sha256',
        excluded: 'Excluído por ratificação (não viaja)',
        secretKeys: 'Chaves env secretas omitidas (#307) — reintroduza-as após um restauro'
      },
      restore: {
        action: 'Restaurar',
        title: 'Restauro',
        submit: 'Restaurar',
        error: 'O restauro não arrancou',
        stillRunning: 'Restauro ainda em curso — extrair árvores inteiras leva tempo.',
        onlyComplete: 'A cópia está {phase}: só uma cópia concluída pode restaurar.',
        asNew: {
          ct: 'Num contentor NOVO — não destrói nada: o gesto com que se verifica uma cópia',
          app: 'Numa App NOVA — não destrói nada: o gesto com que se verifica uma cópia'
        },
        over: {
          ct: 'SOBRE o contentor de origem — a árvore rootfs inteira é substituída',
          app: 'SOBRE a App de origem — o conteúdo de cada volume persistente é substituído'
        },
        name: 'Nome do novo objeto',
        storage: 'Armazenamento',
        storageHint: 'Onde aterram os dados restaurados — o manifesto nunca regista o pool perdido.',
        storageDeclared: 'Os armazenamentos declarados no manifesto',
        bridge: 'Bridge do anfitrião',
        bridgeHint:
          'Cada placa registada volta nesta bridge com um MAC novo. Vazio = nasce desligado, o predefinido mais seguro.',
        node: 'Nó',
        nodeHint: 'O membro em que a App renasce: o nó é identidade de cluster e nunca vem do manifesto.',
        secretKeysWarning:
          'Os valores env declarados secretos não viajam na cópia: a cópia renascida quer que sejam reintroduzidos (o registo do task nomeia as chaves).',
        overInventory: 'Está prestes a sobrescrever este objeto',
        confirmType: 'Escreva {name} para confirmar',
        targetGone: 'O objeto de origem já não pode ser lido: resta o restauro como novo.',
        targetLoading: 'A ler o objeto alvo…',
        targetRunning: 'O objeto alvo está em execução: o restauro substitui os bytes sob o guest e quere-o parado.'
      }
    }
  }
}
